import { gql } from '@apollo/client';

export const SET_OFFICER_INCIDENT_TIMES = gql`
  mutation setOfficerIncidentTimes($input: SetOfficerIncidentTimesInput!) {
    setOfficerIncidentTimes(input: $input) {
      __typename
      clientMutationId
      errors
      officerIncidentSpecificUuid
      officerIncidentSpecific {
        __typename
        arrivedAtHospitalAt
        clearedAt
        currentOfficerStatus
        dispatchedAt
        enrouteAt
        enrouteToHospitalAt
        fieldCheck
        id
        incidentId
        lastContactedAt
        logCodeId
        officer {
          __typename
          id
          deptAttribute {
            __typename
            assignment
            badge
            carNumber
            id
            lastContactedAt
            notes
            ori {
              id
              oriName
              abbreviation
              municipalityNumber
            }
            radioNumber
            secondaryAddress
            skillsList
            status
          }
        }
        onSceneAt
        primaryOfficer
        secondaryAddress
        statusId
      }
    }
  }
`

// {
//   "input": {
//     "officerIncidentSpecificId": 3472,
// "arrivedAtHospitalAt": String,
// "dispatchedAt": String,
// "enrouteAt": String,
// "enrouteToHospitalAt": String,
// "onSceneAt": String,
// "clearedAt": String,
// "clientMutationId": String
//   }
// }
